module.exports = __webpack_public_path__ + "img/itemFooter.8b3ea38a.png";